import DocumentService from "./DocumentService";

const DocumentMapService = {};

const getScrollElementById = (scrollId) => {
  if (!scrollId) return null;
  return document.getElementById(scrollId);
};

//Map
DocumentMapService.resetMap = () => {
  const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
  if (!existingMap) {
    console.log("No map found to reset. The map is already cleared.");
    return;
  }
  localStorage.removeItem("DOCUMENT_MAP_SERVICE");
};

DocumentMapService.initializeMap = (totalPages) => {
  const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
  if (!existingMap) {
    const map = Array(totalPages).fill(-1);
    localStorage.setItem("DOCUMENT_MAP_SERVICE", JSON.stringify(map));
  }
};

DocumentMapService.isPageLoaded = (pageNumber) => {
  return DocumentMapService.getPagePositionByPageNumber(pageNumber) !== -1;
}

DocumentMapService.updateMap = (startPageNumberToUpdate, pagesCountToUpdate) => {
  const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
  if (!existingMap) return;
  const map = JSON.parse(existingMap);
  const startPageIndex = startPageNumberToUpdate - 1;
  if (startPageIndex < 0 || startPageIndex + pagesCountToUpdate > map.length) return;

  for (let i = 0; i < pagesCountToUpdate; i++) {
    map[startPageIndex + i] = startPageIndex + i;
  }

  localStorage.setItem("DOCUMENT_MAP_SERVICE", JSON.stringify(map));
};

DocumentMapService.updatePagesList = (currentList, newPages, newIndexPosition) => {
  const amountPagesNotLoaded = DocumentMapService.getAmountOfPreviousPagesNotLoaded(newIndexPosition) - 1;
  currentList.splice(newIndexPosition - amountPagesNotLoaded, 0, ...newPages);

  return currentList;
};

//From position to page number
DocumentMapService.getPageNumberByPagePosition = (pagePosition) => {
  const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
  if (!existingMap) return null;
  const map = JSON.parse(existingMap);
  const index = map.indexOf(pagePosition);
  return pagePosition + 1
  // return index !== -1 ? index + 1 : false;
};

//From page number to position
DocumentMapService.getPagePositionByPageNumber = (pageNumber) => {
  const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
  if (!existingMap) return null;
  const map = JSON.parse(existingMap);
  return pageNumber >= 1 && pageNumber <= map.length ? map[pageNumber - 1] : null;
};

//From scroll to page number

DocumentMapService.getPageNumberByScroll = (scrollId, totalPagesLoaded, currentPage) => {
  // getDocumentPageHeight
  const scrollContainer = getScrollElementById(scrollId);
  if (!scrollContainer || !totalPagesLoaded) return currentPage || 1;

  const scrollTop = scrollContainer.scrollTop;
  const pageSize = scrollContainer.scrollHeight / totalPagesLoaded;
  const pagePosition = Math.floor(scrollTop / pageSize);
  const previousPagesNotLoaded = DocumentMapService.getAmountOfPreviousPagesNotLoaded(currentPage - 1);

  return DocumentMapService.getPageNumberByPagePosition(pagePosition + previousPagesNotLoaded);
};

DocumentMapService.getPageNumberByScrollWithRealHeights = (scrollId, totalPagesLoaded, currentPage) => {
  const scrollContainer = getScrollElementById(scrollId);
  if (!scrollContainer || !totalPagesLoaded) return currentPage || 1;
  const scrollTop = scrollContainer.scrollTop;

  // Get all page images (both regular and on-preview forms)
  const pageImages = document.querySelectorAll('.pdf-images, .pdf-images-on-preview');

  if (pageImages.length === 0) {
    // Fallback to old method if no images found
    return DocumentMapService.getPageNumberByScroll(scrollId, totalPagesLoaded, currentPage);
  }

  // Calculate accumulated heights for each page
  const pagePositions = [];
  let accumulatedHeight = 0;

  for (let i = 0; i < pageImages.length; i++) {
    pagePositions.push({
      pageNumber: i + 1,
      startPosition: accumulatedHeight,
      endPosition: accumulatedHeight + pageImages[i].offsetHeight
    });
    accumulatedHeight += pageImages[i].offsetHeight;
  }

  // Determine which page the scroll is on
  let currentPageNumber = 1;
  for (let j = 0; j < pagePositions.length; j++) {
    if (scrollTop >= pagePositions[j].startPosition &&
      scrollTop < pagePositions[j].endPosition) {
      currentPageNumber = pagePositions[j].pageNumber;
      break;
    }
  }

  // If scroll is at the end, assign the last page
  const scrollMaxValue = accumulatedHeight - scrollContainer.clientHeight;
  if (scrollTop >= scrollMaxValue) {
    currentPageNumber = pagePositions.length;
  }

  return currentPageNumber;
};

DocumentMapService.getPageNumberBySmallScroll = (scrollId, totalPagesLoaded, currentPage) => {
  // getDocumentPageHeight
  const scrollContainer = getScrollElementById(scrollId);
  if (!scrollContainer || !totalPagesLoaded) return currentPage || 1;

  const scrollTop = scrollContainer.scrollTop;
  const pageSize = scrollContainer.scrollHeight / totalPagesLoaded;
  let pagePosition = Math.ceil(scrollTop / pageSize);
  const previousPagesNotLoaded = DocumentMapService.getAmountOfPreviousPagesNotLoaded(currentPage - 1);
  pagePosition = pagePosition + previousPagesNotLoaded;

  if (scrollContainer.scrollTop + scrollContainer.clientHeight === scrollContainer.scrollHeight) {
    pagePosition = totalPagesLoaded - 1;
  }

  return DocumentMapService.getPageNumberByPagePosition(pagePosition);
};

DocumentMapService.getPageNumberBySmallScrollWithRealHeights = (scrollId, totalPagesLoaded, currentPage) => {
  const scrollContainer = getScrollElementById(scrollId);
  if (!scrollContainer || !totalPagesLoaded) return currentPage || 1;
  const scrollTop = scrollContainer.scrollTop;

  // Get all small page images
  const smallPageImages = document.querySelectorAll('.small-image');

  if (smallPageImages.length === 0) {
    // Fallback to old method if no images found
    return DocumentMapService.getPageNumberBySmallScroll(scrollId, totalPagesLoaded, currentPage);
  }

  // Calculate accumulated heights for each page
  const pagePositions = [];
  let accumulatedHeight = 0;

  for (let i = 0; i < smallPageImages.length; i++) {
    pagePositions.push({
      pageNumber: i + 1,
      startPosition: accumulatedHeight,
      endPosition: accumulatedHeight + smallPageImages[i].offsetHeight
    });
    accumulatedHeight += smallPageImages[i].offsetHeight;
  }

  // Determine which page the scroll is on
  let currentPageNumber = 1;
  for (let j = 0; j < pagePositions.length; j++) {
    if (scrollTop >= pagePositions[j].startPosition &&
      scrollTop < pagePositions[j].endPosition) {
      currentPageNumber = pagePositions[j].pageNumber;
      break;
    }
  }

  // If scroll is at the end, assign the last page
  const scrollMaxValue = accumulatedHeight - scrollContainer.clientHeight;
  if (scrollTop >= scrollMaxValue) {
    currentPageNumber = pagePositions.length;
  }

  return currentPageNumber;
};

//From page number to scroll
DocumentMapService.determinePageScrollPosition = (pageNumber, totalPagesLoaded, documentPageHeight) => {
  return (documentPageHeight / totalPagesLoaded) * pageNumber;
};

DocumentMapService.setScrollByPageNumber = (scrollRef, pageNumber, totalPagesLoaded, scrollFlag) => {
  if (!scrollRef?.current || !totalPagesLoaded) return;
  if (scrollFlag?.current !== undefined) scrollFlag.current = true;

  const pageSize = scrollRef.current.scrollHeight / totalPagesLoaded;
  const pagePosition = DocumentMapService.getPagePositionByPageNumber(pageNumber);
  // is previous pages are not loaded, we have to substract their scroll height
  const previousPagesNotLoadedSize = DocumentMapService.getAmountOfPreviousPagesNotLoaded(pagePosition) * pageSize;
  scrollRef.current.scrollTop = (pageSize * pagePosition) - previousPagesNotLoadedSize;
};

DocumentMapService.setScrollByPageNumberWithRealHeights = (scrollRef, pageNumber, totalPagesLoaded, scrollFlag) => {
  if (!scrollRef?.current || !totalPagesLoaded) return;
  if (scrollFlag?.current !== undefined) scrollFlag.current = true;

  // Get all page images (both regular and on-preview forms)
  const pageImages = document.querySelectorAll('.pdf-images, .pdf-images-on-preview');

  if (pageImages.length === 0) {
    // Fallback to old method if no images found
    const pageSize = scrollRef.current.scrollHeight / totalPagesLoaded;
    const pagePosition = DocumentMapService.getPagePositionByPageNumber(pageNumber);
    const previousPagesNotLoadedSize = DocumentMapService.getAmountOfPreviousPagesNotLoaded(pagePosition) * pageSize;
    scrollRef.current.scrollTop = (pageSize * pagePosition) - previousPagesNotLoadedSize;
    return;
  }

  // Calculate accumulated heights for each page
  const pagePositions = [];
  let accumulatedHeight = 0;

  for (let i = 0; i < pageImages.length; i++) {
    pagePositions.push({
      pageNumber: i + 1,
      startPosition: accumulatedHeight,
      endPosition: accumulatedHeight + pageImages[i].offsetHeight
    });
    accumulatedHeight += pageImages[i].offsetHeight;
  }

  // Find the target page position
  const targetPage = pagePositions.find(pos => pos.pageNumber === pageNumber);

  if (targetPage) {
    scrollRef.current.scrollTop = targetPage.startPosition;
  }
};

DocumentMapService.getAmountOfPreviousPagesNotLoaded = (pagePosition) => {
  const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
  if (!existingMap) return -1;
  const map = JSON.parse(existingMap);
  let previousPagesCount = 0;

  for (let i = pagePosition; i >= 0; i--) {
    if (map[i] === -1) {
      previousPagesCount++;
    }
  }

  return previousPagesCount;
};

DocumentMapService.getLoadedValues = () => {
  const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
  if (!existingMap) return [];
  const map = JSON.parse(existingMap);
  return map.filter((value) => value !== -1);
}
DocumentMapService.determineNeighborPageNumberToFetch = (currentPage) => {
  const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
  if (!existingMap) return -1;
  const map = JSON.parse(existingMap);
  const currentPageIndex = map.indexOf(currentPage);
  if (currentPageIndex === -1) return -1;
  return map[currentPageIndex + 1] === -1 ? map.indexOf(map[currentPageIndex + 1]) + 2 : -1;
};

DocumentMapService.getImagesHeightsAverage = (imagesClassName) => {
  const images = document.getElementsByClassName(imagesClassName);
  const imagesArray = Array.from(images);
  let totalHeight = 0;

  imagesArray.forEach((image) => {
    totalHeight += image.offsetHeight;
  })

  return totalHeight / imagesArray.length;
}

// DocumentMapService.determinePagePosition = (newPageNumber, lastPagePosition) => {
//   const existingMap = localStorage.getItem("DOCUMENT_MAP_SERVICE");
//   if (!existingMap) return null;
//   const map = JSON.parse(existingMap);
//   if (newPageNumber < 0 || newPageNumber > map.length) return null;
//   for (let i = lastPagePosition; i >= 0; i--) {
//     if (newPageNumber > DocumentMapService.getPageNumberByPagePosition(i)) return i + 1;
//   }
//   return 0;
// };

DocumentMapService.determinePageNumberToRender = (pageNumber, totalPages) => {
  if (pageNumber === 1) return 1;
  if (pageNumber > totalPages) return totalPages;

  // Render onDemand by scrolling down
  if (DocumentMapService.isPageLoaded(pageNumber)) return DocumentMapService.getNextMultipleOfFourPlusOne(pageNumber);

  // Render by go to page
  return DocumentMapService.getPreviousMultipleOfFourPlusOne(pageNumber);
};

DocumentMapService.getNextMultipleOfFourPlusOne = (pageNumber) => {
  if (pageNumber < 1) return 1;
  const nextMultipleOfFour = Math.ceil(pageNumber / 4) * 4;
  return nextMultipleOfFour + 1;
};

DocumentMapService.getPreviousMultipleOfFourPlusOne = (pageNumber) => {
  if (pageNumber < 1) return 1;
  const previousMultipleOfFour = Math.floor((pageNumber - 1) / 4) * 4;
  return previousMultipleOfFour + 1;
};

DocumentMapService.checkIfPageNumberIsMultipleOfFourPlusOne = (pageNumber) => {
  if (pageNumber < 1) return false;
  return (pageNumber - 1) % 4 === 0;
}

export default DocumentMapService;
